import cx from 'classnames'
import Link from 'next/link'
import type { ReactNode } from 'react'

import classes from './styles.module.scss'

type Props = {
  href: string
  children?: ReactNode
  className?: string
  size?: 'small' | 'large'
  variant?: 'outlined' | 'contained'
  target?: string
  rel?: string
  onClick?: () => void
}

export default function ButtonLink({ href, children, className, size, variant = 'contained', ...rest }: Props) {
  return (
    <Link
      href={href}
      prefetch={false}
      className={cx(
        size && `mt-button-${variant}-size-${size}`,
        'mt-button-base-root',
        `mt-button-${variant}`,
        classes.button,
        className,
      )}
      {...rest}
    >
      {children}
    </Link>
  )
}
